const translations = {
  "en": {
    "Payment received. Your membership will be activated shortly.": "Payment received. Your membership will be activated shortly."
  },
  "zh-tw": {
    "Payment received. Your membership will be activated shortly.": "付款已收到。您的會員資格即將啟用。"
  }
};

export default translations;
